import type { JSX } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AppShell, Box, ScrollArea, Text } from '@mantine/core';
import NavItems from '../../config/navItems';
import { useAuthorization } from '../../hooks';
import classes from './AppNavbar.module.css';

interface IAppNavbarProps {
  onNavClick?: () => void;
}

function AppNavbar({ onNavClick }: Readonly<IAppNavbarProps>): JSX.Element {
  const location = useLocation();
  const { can, isAuthenticated } = useAuthorization();
  const navItems = NavItems().filter(
    (item) => !item.capability || (isAuthenticated && can(item.capability))
  );

  return (
    <AppShell.Navbar className={classes.navbar}>
      <AppShell.Section className={classes.brand}>
        <Text className={classes.brandText}>Grace Bible Church</Text>
      </AppShell.Section>

      <AppShell.Section grow component={ScrollArea} className={classes.linksSection}>
        {navItems.map(({ id, name, icon: Icon, path }) => (
          <Box
            key={id}
            component={Link}
            to={path}
            className={classes.link}
            data-active={
              (path === '/' ? location.pathname === '/' : location.pathname.startsWith(path)) ||
              undefined
            }
            onClick={onNavClick}
          >
            <Icon className={classes.linkIcon} />
            <span>{name}</span>
          </Box>
        ))}
      </AppShell.Section>
    </AppShell.Navbar>
  );
}

export default AppNavbar;
